import { Input, Form, Button, Upload } from "antd";
import { useCallback, useEffect, useState } from "react";
import { Warning2, DocumentUpload } from "iconsax-react";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import {
  ref as sRef,
  uploadBytes,
  getDownloadURL,
  getStorage,
} from "firebase/storage";
import { useProfiles } from "../../../hooks/profile";
import { useAuth } from "../../../hooks/auth";

import PageHeader from "../../../components/PageHeader";
import { useClass } from "../../../hooks/class";

import { Container, Main, Fieldset, Legend, FooterConfig } from "./styles";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../components/Breadcrumb";

function FormClass() {
  const { createClass, loadingClass } = useClass();
  const [name] = useState("");
  interface FormProps {
    name: string;
    description: string;
    size: number;
    begin: any;
    end: any;
    tumblr: string;
  }
  const [tumblr, setTumblr] = useState("");

  const navigate = useNavigate();
  const { getAll } = useProfiles();
  const { user } = useAuth();

  useEffect(() => {
    if (user && user.type !== "admin" && !user.isAdmin) {
      navigate("/403");
      return;
    }

    async function loadData() {
      if (!user?.uid) return;
      try {
        await getAll(user.uid);
      } catch (error) {
        navigate("/");
      }
    }
    loadData();
  }, [getAll, navigate, user]);

  const handleCreateClass = useCallback(
    async ({ name, begin, end, description, size }: FormProps) => {
      console.log(name);
      await createClass({
        name,
        begin,
        end,
        description,
        size,
        tumblr,
      });
    },
    [createClass, tumblr]
  );

  function geraStringAleatoria(tamanho: number) {
    let stringAleatoria = "";
    const caracteres =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < tamanho; i += 1) {
      stringAleatoria += caracteres.charAt(
        Math.floor(Math.random() * caracteres.length)
      );
    }
    return stringAleatoria;
  }

  const customUpload = async ({ file }: any) => {
    const storage = getStorage();
    const metadata = {
      contentType: "image/jpeg/",
    };

    const nick = geraStringAleatoria(16);
    if (!user?.uid) return;
    const fileName = user.uid;
    const imgFile = sRef(storage, `tumblrClass/${fileName + nick}.png`);
    Swal.fire({
      title: "Realizando envio...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: async () => {
        Swal.showLoading();
        try {
          await uploadBytes(imgFile, file, metadata);
          console.log("enviou");
          const downloadUrl = await getDownloadURL(imgFile);
          setTumblr(downloadUrl);
          Swal.close();
          Swal.fire({
            icon: "success",
            showConfirmButton: false,
            timer: 1000,
          });
        } catch (e) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Aconteceu algum erro inesperado.\nTente novamente.",
          });
          console.log(e);
        }
      },
    });
  };

  /* eslint-disable jsx-a11y/label-has-associated-control */
  return (
    <Container id="class-form" className="container">
      <PageHeader
        title="Adicionar Nova Turma"
        description="Preencha o formulário abaixo para adicionar uma nova turma"
        type="private"
      />
      <Main>
        <Breadcrumb
          items={[
            { label: "Gerenciamento", link: "/manager" },
            { label: "Turmas", link: "/classes" },
            { label: "Cadastro", active: true },
          ]}
        />
        <Form onFinish={handleCreateClass}>
          <Fieldset>
            <Legend>Dados da Turma</Legend>

            <label htmlFor="name">Nome da Turma</label>
            <Form.Item name="name">
              <Input
                name="name"
                value={name}
                placeholder="Insira o nome da Turma"
              />
            </Form.Item>

            <label htmlFor="size">Descrição da turma</label>
            <Form.Item
              name="description"
              rules={[
                { required: true, message: "A descrição é obrigatória!" },
              ]}
            >
              <Input
                name="description"
                placeholder="Insira a descrição da Turma"
                showCount
                maxLength={120}
              />
            </Form.Item>

            <label htmlFor="size">Quantidade de alunos permitidos</label>
            <Form.Item name="size">
              <Input
                name="size"
                type="number"
                min={1}
                placeholder="insira a quantidade de alunos permitidos"
              />
            </Form.Item>

            <label htmlFor="tumblr">Capa da Turma</label>
            <br />
            <label htmlFor="tumblr">
              formatos aceitos: (.png, .jpg, .jpeg)
            </label>

            <Form.Item>
              <Upload
                accept=".png, .jpg, .jpeg"
                name="tumblr"
                customRequest={customUpload}
                style={{ width: "100%", marginTop: "20px" }}
                listType="picture"
                maxCount={1}
              >
                <Button
                  htmlType="button"
                  style={{
                    width: "100%",
                    textAlign: "start",
                    height: "5.6rem",
                    borderRadius: "0.8rem",
                  }}
                  icon={<DocumentUpload size={18} />}
                >
                  Anexar imagem
                </Button>
              </Upload>
            </Form.Item>

            <div className="datePicker">
              <div style={{ width: "40%" }}>
                <label htmlFor="begin">Início das aulas da turma</label>
                <Form.Item name="begin">
                  <Input name="begin" type="date" />
                </Form.Item>
              </div>
              <div style={{ width: "40%" }}>
                <label htmlFor="end">Fim das aulas da turma</label>
                <Form.Item name="end">
                  <Input name="end" type="date" />
                </Form.Item>
              </div>
            </div>
          </Fieldset>
          <FooterConfig>
            <p>
              <Warning2 size={48} />
              Atenção! <br />É necessário preecher todos os dados.
            </p>
            <Button htmlType="submit" disabled={loadingClass}>
              Salvar cadastro
            </Button>
          </FooterConfig>
        </Form>
      </Main>
      <Footer />
    </Container>
  );
}

export default FormClass;
